module.exports = __webpack_public_path__ + "img/time.ba916525.png";